import * as PIXI from 'pixi.js-legacy';

import productService from '../../services/products';
import tacHelpers from '../../state/tac/tacHelpers';
import geometry from '../util/geometry';
import project from '../util/project';

const LEFT = 'left';
const RIGHT = 'right';

const bracketsMixin = superclass =>
  class extends superclass {
    // Override
    drawBracket(side) {
      if (!productService.getFittingBracket(this.item)) {
        // this is not a bracketed item
        return;
      }
      if (this._isDragging) {
        this.bracketContainers[side].alpha = 0;
        return;
      }
      this.bracketContainers[side].alpha = 1;

      let bracket = tacHelpers.getItem(
        this.app.tac,
        this.brackets?.[side]?.itemRef
      );

      if (this.brackets?.[side]?.parent) {
        if (bracket) {
          return;
        } else {
          this.bracketContainers[side].removeChildren();
          delete this.brackets[side];
        }
      }

      const parent = tacHelpers.getParent(this.app.tac, this.item);
      if (!parent) {
        return;
      }

      const proppingTop = this._getProppingTop();

      const tacItem = tacHelpers.getItem(this.app.tac, this.item.itemid);
      const gItem = tacHelpers.getGlobalCoords(tacItem, this.app.tac);

      if (!bracket) {
        const brackets = parent.uprights
          .map(upright => {
            return tacHelpers.getItem(this.app.tac, upright.itemid);
          })
          .filter(upright =>
            side === LEFT ? upright.x <= parent.x : upright.x > parent.x
          )
          .flatMap(upright => upright.items)
          .filter(item => productService.isType(item, 'bracket'));

        const tacItem = tacHelpers.getItem(this.app.tac, this.item.itemid);
        const gItem = tacHelpers.getGlobalCoords(tacItem, this.app.tac);
        const padding =
          side === RIGHT ? { left: -50, right: 20 } : { left: 20, right: -50 };

        padding.bottom = 1;

        // Possible to collide with multiple brackets, then choose the closest one on the Y-axis
        const collidingBrackets = brackets.filter(bracket => {
          const gBracket = tacHelpers.getGlobalCoords(bracket, this.app.tac);
          return geometry.collides(gItem, gBracket, padding);
        });

        if (collidingBrackets.length > 1) {
          bracket = collidingBrackets.reduce((prev, curr) => {
            const gBracketPrev = tacHelpers.getGlobalCoords(prev, this.app.tac);
            const gBracketCurr = tacHelpers.getGlobalCoords(curr, this.app.tac);
            return Math.abs(
              gBracketCurr.y + gBracketCurr.height - (gItem.y + gItem.height)
            ) <
              Math.abs(
                gBracketPrev.height + gBracketPrev.y - (gItem.height + gItem.y)
              )
              ? curr
              : prev;
          });
        } else {
          bracket = collidingBrackets[0];
        }

        if (!bracket) {
          return;
        }
      }

      const gBracket = tacHelpers.getGlobalCoords(bracket, this.app.tac);

      const bracketOffset =
        gBracket.y + gBracket.height - (gItem.y + gItem.height);

      // we've found the bracket we want
      const resourceName = this.getResourceName(bracket);
      const resource = PIXI.Loader.shared.resources[resourceName];
      this.brackets[side] =
        this.brackets[side] || new PIXI.Sprite(resource.texture);
      const outerSize = project.outer(bracket);
      this.brackets[side].width = outerSize.width * this.ratio;
      this.brackets[side].height = outerSize.height * this.ratio;
      this.brackets[side].itemRef = bracket.itemid;
      if (side === RIGHT) {
        this.brackets[side].x = this.sprite.width - this.brackets[side].width;
      } else if (side === LEFT) {
        const bracketPairBox = {
          ...bracket,
          width: this.item.width,
        };
        const bracketPairBoxSize = project.outer(bracketPairBox);

        this.brackets[side].x =
          this.sprite.width - bracketPairBoxSize.width * this.ratio;
      }
      this.brackets[side].y = (proppingTop - bracketOffset) * this.ratio;

      if (!this.brackets[side].parent) {
        this.bracketContainers[side].addChild(this.brackets[side]);
      }
    }
  };

export default bracketsMixin;
